<template>
  <div class="food-list">
    <div
      v-if="!items"
      class="food-item"
    />
    <div
      v-else-if="!items.length"
      class="food-item"
    >
      No results to show yet.
    </div>
    <div
      v-for="(item,key, index) in items"
      v-else
      class="food-item"
    >
      <div class="split">
        <!-- Thumbnail -->
        <div
          class="graphic"
          :class="[item.image_url ? 'has-image' : '']"
        >
          <div
            v-if="item.image_url"
            class="image"
            :style="{'background-image': 'url(' + item.image_url + ')'}"
          />
          <div class="action food-factor">
            <div
              class="food-factor-circle"
              :class="[item.color.toLowerCase()]"
            >
              <auto-fit-text>
                {{ normalizedFactor(item) }}{{ item.color.toUpperCase().substring(0,1) }}
              </auto-fit-text>
            </div>
          </div>
        </div>

        <div class="info">
          <h4 style="word-break:break-word">
            {{ item.name }}
          </h4>
          <div class="line-group">
            <div class="line">
              <span class="label">Food ID #:</span> {{ item.ss_id }}
            </div>
            <div class="line">
              <span class="label">Category:</span> {{ item.cats }}
            </div>
          </div>
          <div class="line-group">
            <div class="line">
              <span class="label">Allergens:</span> {{ item.alls }}
            </div>
            <div
              v-if="item.restaurant!=''"
              class="line"
            >
              <span class="label">Restaurant:</span> {{ item.restaurant }}
            </div>
            <div class="line">
              <span class="label">Standard Serving:</span>
              <a
                v-if="item.serving_unit=='g' || item.serving_unit=='g.'"
                id="dropdownMenuButton"
                class="dropdown-toggle"
                :data-serving="item.serving_unit"
              >{{ parseFloat(item.serving_amount).toFixed(2) }} {{ friendly_units[item.serving_unit] }}</a>
              <a
                v-else
                id="dropdownMenuButton"
                class="dropdown-toggle"
                :data-serving="item.serving_unit"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >{{ parseFloat(item.serving_amount).toFixed(2) }} {{ friendly_units[item.serving_unit] }}</a>
              <div
                class="dropdown-menu"
                aria-labelledby="dropdownMenuButton"
              >
                <h6 class="dropdown-header">
                  Show this amount in...
                </h6>
                <a
                  class="dropdown-item"
                  @click="unit_conversion(key, 'teaspoon')"
                >{{ friendly_units['teaspoon'] }}</a>
                <a
                  class="dropdown-item"
                  @click="unit_conversion(key, 'tablespoon')"
                >{{ friendly_units['tablespoon'] }}</a>
                <a
                  class="dropdown-item"
                  @click="unit_conversion(key, 'cp')"
                >{{ friendly_units['cp'] }}</a>
                <a
                  class="dropdown-item"
                  @click="unit_conversion(key, 'pt')"
                >{{ friendly_units['pt'] }}</a>
                <a
                  class="dropdown-item"
                  @click="unit_conversion(key, 'qt')"
                >{{ friendly_units['qt'] }}</a>
                <a
                  class="dropdown-item"
                  @click="unit_conversion(key, 'gal')"
                >{{ friendly_units['gal'] }}</a>
                <a
                  class="dropdown-item"
                  @click="unit_conversion(key, 'floz')"
                >{{ friendly_units['floz'] }}</a>
              </div>
              <span
                v-if="item.serving_text"
                class="label"
              >{{ item.serving_text }}</span>
            </div>
          </div>
        </div>
        <div class="actions">
          <div class="action">
            <button
              class="button"
              @click="updatemodalData(item); is_showing_add_meal_modal = true; "
            >
              Add to Meal Log
            </button>
          </div>
          <div
            class="action favorite"
            :class="item.is_favorite===true ? 'on':''"
            @click="toggle_favorite(key)"
          >
            <div class="icon">
              <i
                v-if="item.is_favorite===true"
                class="fas fa-heart"
              />
              <i
                v-else
                class="far fa-heart"
              />
            </div>
            <span>{{ item.is_favorite===true ? 'In Your Favorites' : 'Add to Favorites' }}</span>
            <i
              v-tooltip:top="item.is_favorite === true ? 'Unclick the heart to remove the food item from your favorites.' : 'Do you eat this food frequently? If so, add it to your favorites for quicker food entries next time!'"
              class="text-primary fa fa-info-circle"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- <pagination></pagination> -->

    <div class="suggest-food-box">
      <div class="inner">
        <p><strong>Can't find a food?</strong> Submit it here and we will add it to our database so that you can get its Factor and Color!</p>
        <div class="button-container">
          <a
            class="button"
            @click="is_showing_suggest_food_modal = true"
          >Suggest a Food</a>
        </div>
      </div>
    </div>

    <!-- Suggest Food Modal -->
    <form
      v-show="is_showing_suggest_food_modal"
      class="fff-modal suggest-food-modal"
      @submit.prevent="submit_suggest_food"
    >
      <div
        class="overlay"
        @click="is_showing_suggest_food_modal = false"
      />
      <div class="box">
        <div
          class="close-modal"
          @click="is_showing_suggest_food_modal = false"
        >
          &times;
        </div>

        <!-- Fields -->
        <div
          v-show="!suggest_food_data.is_success"
          class="field"
        >
          <h2>Suggest a Food</h2>
        </div>
        <div
          v-show="!suggest_food_data.is_success"
          class="field"
        >
          <p>Can't find a food you are looking for?  Submit it to us here and we'll add it to our database!  Include as many as you like in the box below:</p>
        </div>
        <div
          v-show="!suggest_food_data.is_success"
          class="field"
        >
          <textarea
            v-model="suggest_food_data.suggestion"
            name="name"
            rows="8"
            class="fff-ui"
            placeholder="Write here..."
          />
        </div>
        <div
          v-show="!suggest_food_data.is_success"
          class="field"
        >
          <div class="button-container fluid">
            <button
              type="submit"
              class="button fluid"
            >
              Submit
            </button>
          </div>
        </div>

        <!-- Success -->
        <div
          v-show="suggest_food_data.is_success"
          class="field text-center"
        >
          <h2>Submitted</h2>
        </div>
        <div
          v-show="suggest_food_data.is_success"
          class="field text-center"
        >
          <p>Awesome, your suggestion has been submitted!</p>
        </div>
        <div
          v-show="suggest_food_data.is_success"
          class="field text-center"
        >
          <a
            class="button tertiary"
            @click="is_showing_suggest_food_modal = false"
          >All Done</a>
        </div>
      </div>
    </form>

    <!-- Add Meal Modal -->
    <add-meal-modal
      v-show="is_showing_add_meal_modal"
      :iteminfo="modalData"
      @hide-modal="is_showing_add_meal_modal = false"
      @meal-log-entry-added="onMealLogEntryAdded"
    />

    <!-- Upgrade Modal -->
    <upgrade-modal
      v-show="is_showing_upgrade_modal"
      @show-modal="is_showing_upgrade_modal = true"
      @hide-modal="is_showing_upgrade_modal = false"
    />
  </div>
</template>

<script>

import { unit } from 'mathjs'
import foodcleaner from './FoodSearchShared'
import {FRIENDLY_UNITS} from "../recipe_maker_vars";

export default {
  props:{
    items:Array
  },
  data () {
    return {
      friendly_units: FRIENDLY_UNITS,
      query: null,
      is_showing_upgrade_modal: false,
      is_showing_suggest_food_modal: false,
      suggest_food_data: {
        suggestion: '',
        is_success: false,
      },
      is_showing_add_meal_modal: false,
      modalData:{}
    }
  },
  computed: {
    searched() {
      return !!this.query;
    },
  },
  watch: {
    is_showing_add_meal_modal: function(){
      if (this.$parent.$parent.user.type != 'individual') {
        this.is_showing_upgrade_modal = true;
        this.is_showing_add_meal_modal = false;
      }
    },
  },
  methods: {
    /**
         * Clear the search text in component FoodSearchbox
         */
    onMealLogEntryAdded() {
      // Trigger event at the root level in order for deeply nested component to detect it
      this.$root.$el.dispatchEvent(new Event('meal-log-entry-added'));

      window.scrollTo(0, 0);
    },
    unit_conversion(item_index, new_unit) {
      // Calculate units
      console.log(item_index+'---'+new_unit);
      console.log(this.items[item_index]);
      var item = this.items[item_index];
      var old_amount = unit(item.serving_amount.toString() + ' ' + item.serving_unit);
      var new_amount = old_amount.to(new_unit);

      // Reset values
      item.serving_amount = new_amount.toNumber();
      item.serving_unit = new_unit;
    },
    async toggle_favorite(item_index) {
      if (this.$parent.$parent.user.type == 'individual') {
        let item = this.items[item_index];
        let updateditem = await this.$http('/api/fooditems/favorites',{
          method:"post",
          body:JSON.stringify({
            'food_items_sid':item.food_items_sid,
            'food_item_spirals_sid':item.food_item_spirals_sid,
            'type_of_food ':item.type_of_food
          }),
        }).then(response => response.json())
          .then(async function(json) {
            console.log(json);
            return json.data;
          });

        let itemData = await foodcleaner.cleanfooditems(updateditem);

        for (let ele in itemData) {
          if ( itemData.hasOwnProperty(ele) ) {
            if ( itemData[ele].food_items_sid == item.food_items_sid ) {
              item.is_favorite = itemData[ele].is_favorite;
              break;
            }
          }
        }

      } else {
        this.is_showing_upgrade_modal = true;
      }
    },
    async submit_suggest_food() {
      let updateditem = await this.$http('/api/suggestions/add',{
        method:"post",
        body:JSON.stringify({
          'message':this.suggest_food_data.suggestion
        }),
      }).then(response => response.json())
        .then(async function(json) {
          console.log(json);

          return json.data;
        });

      this.suggest_food_data.is_success=true;
      this.suggest_food_data.suggestion ='';
    },
    updatemodalData(iteminfo){
      this.modalData['type']='food';
      this.modalData['serving_size']=iteminfo.serving_amount;
      this.modalData['serving_unit']=iteminfo.serving_unit;
      this.modalData['food_items_sid']=iteminfo.food_items_sid;
      this.modalData['food_item_spirals_sid']=iteminfo.food_item_spirals_sid;
      this.modalData['type_of_food']=iteminfo.type_of_food;
      this.modalData['color']=iteminfo.color;
      this.modalData['meal_name']=iteminfo.name;			// To change title in modal
      this.modalData = Object.assign({},this.modalData,this.modalData);
      // console.log("modaldata");
      // console.log(this.modalData);

    },
    /**
         * Convert the factor to the value based off the serving size
         * @param item Object
         * @returns string
         */
    normalizedFactor(item) {
      let factor = parseFloat(item.factor);

      if (item.factor_rec_serving_size && item.factor_rec_serving_size > 0) {
        factor = parseFloat(item.factor_rec_serving_size);
      }

      if (factor > 0) {
        return factor.toString();
      }

      return '0';
    }
  },
}
</script>

<style lang="scss" scoped>
.food-item {
    padding: 24px 0;
    border-bottom: 1px solid #f0f0f0;
}
.food-item .split {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    margin: -24px;
}
.food-item .split > * {
    padding: 24px;
}
.food-item .graphic {
    width: 20%;
    position: relative;
}
.food-item .graphic .image {
    width: 100%;
    height: auto;
    border-radius: 6px;
    padding-bottom: 100%;
    background-color: #f0f0f0;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: cover;
}
.food-item .graphic .food-factor {
    width:100%; padding-bottom:100%; position:relative;
}
.food-item .graphic .food-factor-circle{
    position:absolute; top:5%; left:5%; width:90%; height:90%; font-size:1.2rem;
}

/* image_url is present */
$circle-size: 75px;
.food-item .graphic.has-image .food-factor {
    padding-bottom: 0;
    position: absolute;
    width: $circle-size;
    height: $circle-size;
    bottom: 2px;
    right: -6px;
    top: auto;
    left: auto;

    @media screen and (max-width: 500px) {
        width: 50px;
        height: 50px;
    }

    @media screen and (max-width: 375px) {
        bottom: -12px;
    }
}
.food-item .graphic.has-image .food-factor-circle {
    font-size: 1.2rem !important; border-width:4px;
}
/* adjustments for side items like food groups */
.side .food-item .graphic.has-image .food-factor {
    width: 64px; height: 64px; bottom: -22px; right: -22px;
}
.side .food-item .graphic.has-image .food-factor-circle {
    font-size: 1.1rem !important; border-width:4px;
}

.food-item .info {
    flex: 1;
    min-width: 0;
    padding-top: 24px;
    padding-bottom: 24px;
}
.food-item h4:not(:last-child) {
    margin-bottom: 24px;
}
.food-item .line-group + .line-group {
    margin-top: 16px;
}
.food-item .line {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
}
.food-item .line:not(:first-child) {
    margin-top: 8px;
}
.food-item .line > * {
    margin-right: 8px;
}
.food-item .label {
    font-weight: 700;
}
.food-item .actions {
    padding-top: 24px;
    padding-bottom: 24px;
}
.food-item .action:not(:last-child) {
    margin-bottom: 16px;
}
.food-item .action.favorite {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    cursor: pointer;
}
.food-item .action.favorite .icon {
    display: inline-block;
    color: #aaa;
    margin-right: 12px;
    font-size: 20px;
}
.food-item .action.favorite:hover .icon {
    color: #000;
}
.food-item .action.favorite.on .icon {
    color: #e74c3c;
}
.food-item .action.favorite > i {
    display: inline-block;
    margin-left: 8px;
}
.food-item a.dropdown-toggle {
    color: rgba(95, 159, 59, 1);
    font-weight: 600;
    cursor: pointer;
}
.food-item .dropdown-item{cursor:pointer;}
.food-item .dropdown-item.active{background:#5f9f3b !important;}

@media all and (max-width: 768px) {
    .food-item .split {
        margin: -12px;
    }
    .food-item .split > * {
        padding: 12px;
        margin-left: 14px;
    }
    .food-item .graphic {
        width: 25%;
    }

    .food-item .actions {
        flex: 0 0 100%;
        padding-left: calc(25% + 12px);
        text-align: left;
    }
    .food-item .action.favorite {
        justify-content: flex-start;
    }
}
</style>
